import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/_share/_models/entities/user';
import { UserService } from 'src/app/_share/_services/user.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  currentUser: User = {};
  showPasswordReset: boolean = false;

  constructor(
    public userService: UserService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.userService.getCurrentLoggedInUser();
    this.userService.currentUser$.subscribe((user) => {
      this.currentUser = user;
    });
  }

  openEditUserProfileDialog() {
    this.messageService.add({
      severity: 'info',
      summary: 'Feature Coming Soon',
      detail: 'User profile editing will be available in a future update.',
      life: 3000
    });
  }

  togglePasswordReset() {
    this.showPasswordReset = !this.showPasswordReset;
  }

  onPasswordResetSuccess() {
    this.showPasswordReset = false;
    this.messageService.add({
      severity: 'success',
      summary: 'Password Reset',
      detail: 'Password reset request has been sent successfully.',
      life: 5000
    });
  }
}
